<template>
  <div class="select-city">
    <el-input
      readonly
      v-model="showTextval"
      @click.native="showDialog"
      :style="{ width: width }"
      :placeholder="placeholder"
      @mousemove.native="mouseMove"
      @mouseleave.native="mouseLeave"
    >
      <i @click="handleIconClick" slot="suffix" :class="'el-input__icon el-icon-' + inputIcon + ' pointer'"></i>
    </el-input>
    <el-dialog :visible.sync="dialogVisible" custom-class="dia-w">
      <div>
        <div class="localdata">
          近期选择:
          <span v-for="(val, ind) in localKindData" :key="ind" class="localdata-style" @click="rtnDataFn(val)">{{
            val.text
          }}</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-select v-model="proCode" @change="selectAddress('selectPro', proCode)" placeholder="请选择省">
              <el-option v-for="item in proArr" :label="item.nickName" :value="item.regionCode" :key="item.regionCode">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <el-select v-model="cityCode" @change="selectAddress('selectCity', cityCode)" placeholder="请选择市">
              <el-option v-for="item in cityArr" :label="item.nickName" :value="item.regionCode" :key="item.regionCode">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <el-select v-model="areaCode" placeholder="请选择区">
              <el-option v-for="item in areaArr" :label="item.nickName" :value="item.regionCode" :key="item.regionCode">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from '@/api/axiosNew';
import api from '@/api/base.new.api';

export default {
  name: 'SelectCity',
  data() {
    return {
      showTextval: '',
      dialogVisible: false,
      inputIcon: 'caret-bottom',
      proArr: [],
      proCode: '',
      cityArr: [],
      cityCode: '',
      areaArr: [],
      areaCode: '',
      obj: {},
      localKindData: [] // 本地存储选择数据
    };
  },
  props: {
    type: {
      type: String,
      default: '' // ZH(装货),XH(卸货),''(其他)
    },
    // 这个value仅用来做默认显示文本(初始化时赋给文本框显示)
    // 实际选中对象并没有匹配(不建议给该组件赋默认值 除非父组件已有该文本对应的object  例如编辑模式下使用)
    value: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '220px'
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    // 是否可清空
    clearable: {
      type: Boolean,
      default: false
    }
  },
  created() {
    // 默认显示文本
    this.showTextval = this.value;
    this.selectAddress('', '');
  },
  watch: {
    value: function () {
      this.showTextval = this.value;
    }
  },
  methods: {
    resetData() {
      this.showTextval = '';
      this.selectAddress('', '');
    },
    showDialog() {
      this.dialogVisible = true;
      if (this.type == 'ZH') {
        this.localKindData = JSON.parse(localStorage.getItem('ZHCity'));
      } else if (this.type == 'XH') {
        this.localKindData = JSON.parse(localStorage.getItem('XHCity'));
      }
    },
    selectAddress(type, id) {
      // 地址选择
      switch (type) {
        case 'selectPro':
          this.cityCode = '';
          this.cityArr = [];
          this.areaCode = '';
          this.areaArr = [];
          break;
        case 'selectCity':
          this.areaCode = '';
          this.areaArr = [];
          break;
      }
      if (type == 'selectCity' && id == '') return;

      axios.post(api.getRegionlist, { regioncode: id }).then(res => {
        switch (type) {
          case '':
            this.proArr = res.data;
            break;
          case 'selectPro':
            this.cityArr = res.data;
            break;
          case 'selectCity':
            this.areaArr = res.data;
            break;
        }
      });
    },
    submit() {
      if (this.cityCode == '') {
        this.$message.warning('请选择城市');
        return;
      }
      var obj = {};
      for (let i = 0; i < this.proArr.length; i++) {
        if (this.proCode == this.proArr[i].regionCode) {
          obj.proData = this.proArr[i];
          break;
        }
      }
      for (let i = 0; i < this.cityArr.length; i++) {
        if (this.cityCode == this.cityArr[i].regionCode) {
          obj.cityData = this.cityArr[i];
          break;
        }
      }
      if (this.areaCode != '') {
        for (let i = 0; i < this.areaArr.length; i++) {
          if (this.areaCode == this.areaArr[i].regionCode) {
            obj.areaData = this.areaArr[i];
            break;
          }
        }
      } else {
        obj.areaData = {};
      }
      obj.text = obj.cityData.nickName + (obj.areaData.nickName || '');

      // 这里的返回数据没有考虑到扩展性(例如 需要省文本、城市文本、区域文本、城市坐标)
      // 由于localstrong永久存储  就算改了代码  近期使用数据无法更新o(︶︿︶)o
      // 作为组件 返回数据应劲量不让父组件做判断 这里父组件拿到数据还要判断是否有areacode
      var rtnData = {
        text: obj.text,
        proCode: obj.proData.regionCode,
        cityCode: obj.cityData.regionCode,
        areaCode: obj.areaData.regionCode ? obj.areaData.regionCode : '',
        lat: obj.areaData.regionCode ? obj.areaData.latitude : obj.cityData.latitude,
        lon: obj.areaData.regionCode ? obj.areaData.longitude : obj.cityData.longitude
      };
      this.rtnDataFn(rtnData);
    },
    rtnDataFn(obj) {
      this.showTextval = obj.text;
      this.$emit('select-city', obj);
      if (obj.text == '') return; //清空操作不存储localstrong
      if (this.type == 'ZH') {
        this.setSelectCitydata('ZHCity', obj);
      } else if (this.type == 'XH') {
        this.setSelectCitydata('XHCity', obj);
      }
      this.dialogVisible = false;
    },
    setSelectCitydata(key, obj) {
      var code = obj.areaCode != '' ? obj.areaCode : obj.cityCode;
      var d = [];
      var data = localStorage[key];
      d.push(obj);
      if (data) {
        data = JSON.parse(data);
        for (var i = 0; i < 5; i++) {
          if (data[i]) {
            var itemCode = data[i].areaCode != '' ? data[i].areaCode : data[i].cityCode;
            if (itemCode == code) {
              continue;
            }
            d.push(data[i]);
          } else {
            break;
          }
        }
      }
      localStorage[key] = JSON.stringify(d);
    },
    handleIconClick(ev) {
      // 点击清空图标
      if (this.inputIcon == 'circle-close') {
        event.stopPropagation();
        this.rtnDataFn({
          areaCode: '',
          cityCode: '',
          lat: 0,
          lon: 0,
          proCode: '',
          text: ''
        });
      }
    },
    // 文本框鼠标事件 改变icon支持清空选项
    mouseMove: function (ev) {
      if (this.isClear) {
        if (this.showTextval != '') {
          if (ev.target.tagName.toLocaleLowerCase() == 'i') {
            this.inputIcon = 'circle-close';
          } else {
            this.inputIcon = 'caret-bottom';
          }
        } else {
          this.inputIcon = 'caret-bottom';
        }
      }
    },
    mouseLeave: function () {
      this.inputIcon = 'caret-bottom';
    }
  },
  computed: {
    // 是否可清空
    isClear: function () {
      return this.clearable || false;
    }
  }
};
</script>

<style>
.select-city .dia-w {
  width: 600px;
}
.localdata {
  padding-bottom: 10px;
  border-bottom: 1px solid #e5ebef;
  margin-bottom: 10px;
}
.localdata-style {
  display: inline-block;
  padding: 0 15px;
  cursor: pointer;
  color: #11ab19;
}
.select-city .el-input__inner {
  cursor: pointer;
}
</style>
